import { useEffect, useState } from 'react';

// setTimeout overflows above ~24.8 days and fires immediately.
const MAX_TIMEOUT_MS = 2_147_483_647;

/**
 * Current epoch ms, refreshed every `intervalMs` and additionally right at
 * `wakeAtMs` (when it lies in the future) so deadline-driven UI flips on time.
 */
export function useNow(intervalMs = 30_000, wakeAtMs?: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  useEffect(() => {
    if (wakeAtMs == null) return;
    const delay = wakeAtMs - Date.now();
    if (delay <= 0 || delay > MAX_TIMEOUT_MS) return;
    const id = window.setTimeout(() => setNow(Date.now()), delay + 250);
    return () => window.clearTimeout(id);
  }, [wakeAtMs]);

  return now;
}
